import React, { Component } from "react";
import PropTypes from "prop-types";
import { InsightContent, InsightTitle } from "../styles/main";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { livemonitorSelector, globalStateSelector } from "store/selector";
import LiveAgentState from "./LiveAgentState";
import LiveCallState from "./LiveCallState";
import colors from "../styles/colors";
const uuid = require("uuid");
export class LiveMonitorData extends Component {
  constructor(props) {
    super(props);
  }
  renderTitle(title) {
    const { __ } = this.context;
    return (
      <InsightTitle style={{ paddingTop: "0px", margin: "0px" }}>
        {__(title)}
      </InsightTitle>
    );
  }
  render() {
    let { stateList, inboundState } = this.props;
    return (
      <div style={{ width: "100%" }}>
        <InsightContent className="w-100" style={{ padding: "0px 10px" }}>
          <Row
            className="w-100"
            style={{ overflowY: "auto", height: "calc(100vh - 325px)" }}
          >
            <Col
              className="w-100"
              md={12}
              sm={12}
              lg={12}
              key={Math.random()}
              style={{ padding: "0px" }}
            >
              <LiveCallState list={inboundState} />
              <LiveAgentState list={stateList} />
            </Col>
          </Row>
        </InsightContent>
      </div>
    );
  }
}
LiveMonitorData.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  stateList: livemonitorSelector.getLiveDynamic(state, { key: "state" }),
  inboundState: livemonitorSelector.getLiveDynamic(state, {
    key: "inboundState",
  }),
});

const dispatchToProps = (dispatch) => ({});
export default connect(stateToProps, dispatchToProps)(LiveMonitorData);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveMonitorData.js